import { APP_INITIALIZER, EnvironmentProviders, inject, makeEnvironmentProviders } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { EnvironmentStore } from "../store/environment.store";
import { Variables } from "../interfaces/environment.interface";
import { environment } from "../../../environments/environment";
import { map, tap } from "rxjs";

/**
 * Función que proporciona la configuración del entorno inicializando los
 * componentes.
 *
 * Esta función utiliza variables de entorno y configuraciones obtenidas
 * desde un servidor remoto. Inicializa el entorno estableciendo las
 * variables en el `EnvironmentStore`
 *
 * @function provideEnvironment
 * @returns {EnvironmentProviders} - Devuelve un conjunto de proveedores
 * de entorno, permitiendo la configuración e inicialización adecuada
 * del entorno de la aplicación.
 */
export const provideEnvironment = (): EnvironmentProviders => {
  return makeEnvironmentProviders([
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const http = inject(HttpClient);
        const environmentStore = inject(EnvironmentStore);

        return () => {
          return http.get<Record<string, Variables>>(environment.config, {
            headers: {
              'X-Skip-Interceptor': 'true'
            }
          })
            .pipe(
              tap(data => console.log(data)),
              map(data => data['sfi-rohan-login']),
              tap(data => environmentStore.setVariables(data))
            )
        }
      },
      multi: true
    }
  ]);
};
